import { instantsInterceptor, } from '@/api/index';

function getPdfWaterMark() {
    return instantsInterceptor.get('/mgmt/code/pdf');
}

function savePdfWaterMark(pdf) {
    return instantsInterceptor.post('/mgmt/code/pdf/save', pdf);
}


export { getPdfWaterMark, savePdfWaterMark };